<template>
    <span :class="colorClass">
        {{value}}
    </span>
</template>

<script>
    export default {
        name: "schnitt-feld",
        props: {
            value: {default: null},
            spieler: {default: 1},
        },
        computed: {
            colorClass(){
                const valueTemp = this.value / this.spieler;
                if ( valueTemp >= 700 ) {
                    return 'purpleColor'
                } else if ( valueTemp >= 600 ) {
                    return 'blue--text'
                } else if ( valueTemp >= 540 ) {
                    return 'success--text'
                } else if ( valueTemp >= 480 ) {
                    return 'primary--text'
                } else {
                    return 'text--black'
                }
            }
        },
    }
</script>

<style scoped>
    .purpleColor { color: #D500F9}
</style>